









import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  CommonsStore, AdvertisementsStore, Payload, AuthorizationStore,
} from '@samclick-store-factory';
import Advertisement from '@/views/Programs/Advertisement/Advertisement.vue';
import LandingPages from '@/views/Programs/Advertisement/LandingPages.vue';

class AdsWrapperState {
    activeTab: string = 'media'
}

@Component({
  /**
   * Imported components
   * */
  components: { Advertisement, LandingPages },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      loading: (state: any) => state.advertisements.advertisementsStore.loading,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class AdsWrapper extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new AdsWrapperState();

  /**
   * Watchers
   * */
  @Watch('componentState.var')
    sampleWatcher(newVal: string, oldVal: string) {

    }

  /**
   * Methods
   * */
  actionMethod() {

  }


  /**
   * Computed
   * */
  get computedVal() {
    return {};
  }

  /**
   * Lifecycle hooks
   * */
  created() {}

  mounted() {}

  beforeCreate() {
    AdvertisementsStore.destroyAdvertisements();
    CommonsStore.fetchAllCasino();
    CommonsStore.fetchEnabledCasino();
    CommonsStore.fetchAdsTypes();
    CommonsStore.fetchAllAdsCategory();
    AdvertisementsStore.getCampaignList(new Payload({ affiliateId: AuthorizationStore.currentLoggedUserInState.id, status: 1 }));
    AdvertisementsStore.getLandingPageList(new Payload({ status: 1 })); // 31352
  }
}
